import styled from 'styled-components'
import { SvgImage } from 'components/SvgImage'
import { Color } from 'root-constants'

export const StyledMoneyBackGuarantee = {
  Wrapper: styled.div`
    position: relative;
    margin-bottom: 40px;
    padding: 8px;
    background: #ebe8ff;
    border-radius: 24px;
  `,
  Title: styled.h2`
    margin-bottom: 8px;
    font-weight: 700;
    font-size: 24px;
    line-height: 30px;
    color: ${Color.DARK};
    max-width: 220px;
  `,
  Content: styled.div`
    padding: 16px;
    border-radius: 14px;
  `,
  Text: styled.p`
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: ${Color.DARK};
  `,
  Badge: styled(SvgImage)`
    position: absolute;
    top: 16px;
    right: 16px;
  `,
}
